var map = {
	"./apple.jpg": 489,
	"./aws.jpg": 490,
	"./cruise.jpg": 491,
	"./facebook.png": 492,
	"./google.jpg": 493,
	"./linkedin.jpg": 494,
	"./microsoft.jpg": 495,
	"./salesforce.jpg": 496,
	"./twitter.jpg": 497,
	"./uber.jpg": 405,
	"./waymo.jpg": 498,
	"./workday.jpg": 499
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 824;